export const COMPRESSION_THRESHOLD = 750;
